import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import CarouselArrow from "../../CarouselArrow/CarouselArrow";
import { getImageUrl } from "../../../utils/media";
import "./style.css";

function getAuthorName(post) {
  return post?.author?.name || post?.authorName || "7 Geracoes";
}

export default function FeaturedPostsCarousel({
  posts = [],
  linkPosts = true,
  imageOverride,
  staticTitle,
  staticAuthor,
  staticSlideCount = 3,
}) {
  const displayPosts = useMemo(() => {
    if (!staticTitle) return posts;

    return Array.from({ length: staticSlideCount }, (_, index) => ({
      _id: `blog-featured-${index}`,
      title: staticTitle,
      authorName: staticAuthor,
      images: [],
    }));
  }, [posts, staticAuthor, staticSlideCount, staticTitle]);

  const orderedPosts = useMemo(() => {
    const featured = displayPosts.find((post) => post.featured);
    if (!featured) return displayPosts;

    return [
      featured,
      ...displayPosts.filter((post) => post._id !== featured._id),
    ];
  }, [displayPosts]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [orderedPosts.length]);

  if (orderedPosts.length === 0) return null;

  const previousIndex =
    (activeIndex - 1 + orderedPosts.length) % orderedPosts.length;
  const nextIndex = (activeIndex + 1) % orderedPosts.length;
  const activePost = orderedPosts[activeIndex];

  const changePost = (direction) => {
    setActiveIndex((current) =>
      (current + direction + orderedPosts.length) % orderedPosts.length,
    );
  };

  const renderPreview = (post, position) => {
    const imageUrl = imageOverride || getImageUrl(post?.images?.[0]);

    return (
      <div
        className={`blog-featured__preview blog-featured__preview--${position}`}
        aria-hidden="true"
      >
        {imageUrl ? <img src={imageUrl} alt="" /> : <span>Sem imagem</span>}
      </div>
    );
  };

  const activeImageUrl = imageOverride || getImageUrl(activePost.images?.[0]);
  const cardContent = (
    <>
      {activeImageUrl ? (
        <img src={activeImageUrl} alt="" />
      ) : (
        <span className="blog-featured__placeholder">Sem imagem</span>
      )}
      <div className="blog-featured__overlay">
        <h2>{activePost.title}</h2>
        <p>Por {getAuthorName(activePost)}</p>
      </div>
    </>
  );

  return (
    <section className="blog-featured" aria-label="Posts em destaque">
      <CarouselArrow
        direction="prev"
        className="blog-featured__arrow blog-featured__arrow--prev"
        onClick={() => changePost(-1)}
        ariaLabel="Post anterior"
        disabled={orderedPosts.length < 2}
      />

      <div className="blog-featured__stage">
        {renderPreview(orderedPosts[previousIndex], "previous")}

        {linkPosts ? (
          <Link
            className="blog-featured__card"
            to={`/blog/${activePost.slug || activePost._id || activePost.id}`}
          >
            {cardContent}
          </Link>
        ) : (
          <article className="blog-featured__card">{cardContent}</article>
        )}

        {renderPreview(orderedPosts[nextIndex], "next")}
      </div>

      <CarouselArrow
        direction="next"
        className="blog-featured__arrow blog-featured__arrow--next"
        onClick={() => changePost(1)}
        ariaLabel="Proximo post"
        disabled={orderedPosts.length < 2}
      />
    </section>
  );
}
